export default '/build/8bc0e3f6.jpg'